import(/* webpackMode: "eager" */ "/home/briar/git/DLOM-2-serverless/frontend/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/briar/git/DLOM-2-serverless/frontend/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/briar/git/DLOM-2-serverless/frontend/app/rum-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/home/briar/git/DLOM-2-serverless/frontend/components/error-boundary.tsx");
;
import(/* webpackMode: "eager" */ "/home/briar/git/DLOM-2-serverless/frontend/node_modules/.pnpm/next@15.2.4_react-dom@19.1.1_react@19.1.1__react@19.1.1/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
